export const timeZone = 'Asia/Bangkok'
export const timeFormat = 'YYYY-MM-DDTHH:mm:ss'


// WEBPACK FOOTER //
// ./src/lib/setting.js